import React, { Component } from "react"
import { connect } from "react-redux"
import { Arwes, Button, Project, Frame as FrameC } from "arwes"
import Icon from "@mdi/react"
import { mdiChemicalWeapon } from "@mdi/js"
import styled from "styled-components"
import get from "lodash.get"
import {
  checkIsAuthenticated,
  // isAuthenticated,
  getUserInformation,
  editUserProfile
} from "./redux/reducers"
// import { Redirect } from "react-router-dom"
import { Field, getFormValues, reduxForm } from "redux-form"
import {
  AVATAR_CATEGORIES,
  AVATARS_BY_CATEGORY,
  avatarUrl,
  categoryOf
} from "../../common/util/avatars"
import { MarginTop } from "../../common/styled/MarginTop"
import {
  ContentColumn,
  PageBlock,
  PageOffset
} from "../../common/styled/Page"
// import axios from "axios"

const ASSETS = `${process.env.PUBLIC_URL}/assets`

const isProduction = process.env.NODE_ENV === "production"
const envURL =
  process.env.REACT_APP_API_URL || "https://cybersocial.herokuapp.com"
const PUBLIC_URL = isProduction ? envURL : "http://localhost:8080"

// References:
// https://github.com/erikras/redux-form/issues/3686
// 🔜 https://codesandbox.io/s/z39y9mlwq4
// Example: https://ashiknesin.com/blog/upload-file-using-axios-and-redux-form/

const Hide = styled.div`
  display: ${props => (props.enable ? "flex" : "none")};
  min-width: 0;
  width: 100%;
`

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div>
    <label className={"text-muted"}>{label}</label>
    <div>
      <input
        className={"form-control"}
        {...input}
        placeholder={label}
        type={type}
      />
      {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
)

const ButtonBar = styled.div`
  display: flex;
  justify-content: ${props => (props.right ? "flex-end" : "space-evenly")};
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 8px;
`

const FieldBox = styled.div`
  box-sizing: border-box;
  min-width: 0;
  padding: 20px 40px;
  font-size: 32px;
  width: 100%;
  word-break: break-word;
  text-align: ${p => (p.center ? "center" : "left")};

  ${Hide} > div {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  .form-control {
    width: 100%;
  }

  @media (max-width: 600px) {
    padding: 14px 16px;
    font-size: 22px;
  }
`

const AvatarPreview = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  width: 100%;

  @media (max-width: 600px) {
    padding: 14px 12px;
  }
`

const PickerLabel = styled.div`
  box-sizing: border-box;
  color: #6fbfff;
  font-family: "VT323", monospace;
  padding: 0 20px 10px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 12px 10px;
  }
`

const AvatarTabs = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 20px 12px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 12px 12px;
  }
`

const AvatarGrid = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 460px;
  padding: 0 20px 20px;
  width: 100%;

  @media (max-width: 600px) {
    gap: 6px;
    padding: 0 12px 16px;
  }
`

const AvatarChoice = styled.button`
  appearance: none;
  background: transparent;
  border: 2px solid rgba(111, 191, 255, 0.25);
  box-sizing: border-box;
  box-shadow: none;
  cursor: pointer;
  flex: 0 0 56px;
  height: 56px;
  padding: 0;
  width: 56px;

  &:focus {
    outline: 2px solid #fc26fa;
    outline-offset: 2px;
  }

  &[aria-pressed="true"] {
    border-color: #00e7ff;
    box-shadow: 0 0 10px #00e7ff;
  }

  img {
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  @media (max-width: 360px) {
    flex-basis: 48px;
    height: 48px;
    width: 48px;
  }
`

class EditProfile extends Component {
  state = {
    isEditName: false,
    isEditPassword: false,
    isEditEmail: false,
    isEditAbout: false,
    // Avatar path picked in this session; null = keep current.
    selectedAvatar: null,
    // Picker tab; null = follow the current avatar's category.
    avatarCategory: null
  }

  componentDidMount() {
    this.userData = new FormData()

    // const { match } = this.props
    // const getUserId = get(match, 'match.params.userId')
    const getUserId = this.props.match.params.userId
    this.props.getUserInformation(getUserId)
    //this.props.getUserPhoto(getUserId)
  }

  enableEditName = () => {
    this.setState(prev => ({
      isEditName: !prev.isEditName
    }))
  }
  enableEditEmail = () => {
    this.setState(prev => ({
      isEditEmail: !prev.isEditEmail
    }))
  }
  enableEditPassword = () => {
    this.setState(prev => ({
      isEditPassword: !prev.isEditPassword
    }))
  }
  selectAvatar = name => {
    this.setState({ selectedAvatar: name })
  }
  selectCategory = id => {
    this.setState({ avatarCategory: id })
  }
  enableEditAbout = () => {
    this.setState(prev => ({
      isEditAbout: !prev.isEditAbout
    }))
  }

  onSubmit = values => {
    const { user } = this.props
    let formData = new FormData()
    // Only send fields that actually have a value — appending undefined
    // to FormData stringifies it and saves a literal "undefined".
    if (values.name != null && values.name !== "") {
      formData.append("name", values.name)
    }
    if (this.state.selectedAvatar) {
      formData.append("avatar", this.state.selectedAvatar)
    }
    if (values.about != null) {
      formData.append("about", values.about)
    }

    const getUserId = get(user, "loadedUser._id")

    this.props.editUserProfile(formData, getUserId)
  }

  renderEditPhoto = () => {
    // Uploads are gone — users pick one of the preset avatars instead,
    // browsing one category at a time.
    const currentAvatar =
      this.state.selectedAvatar || get(this.props.user, "loadedUser.avatar")
    const category = this.state.avatarCategory || categoryOf(currentAvatar)
    return (
      <FrameC show={true} animate={true} level={3} corners={4} layer="primary">
        {this.renderPhoto()}
        <PickerLabel>Choose your avatar</PickerLabel>
        <AvatarTabs>
          {AVATAR_CATEGORIES.map(cat => {
            const active = cat.id === category
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => this.selectCategory(cat.id)}
                style={{
                  background: active ? "rgba(0, 231, 255, 0.12)" : "transparent",
                  border: active
                    ? "1px solid #00e7ff"
                    : "1px solid rgba(111, 191, 255, 0.35)",
                  color: active ? "#00e7ff" : "#6fbfff",
                  fontFamily: "VT323, monospace",
                  fontSize: "1rem",
                  letterSpacing: "0.1em",
                  minHeight: 44,
                  maxWidth: "100%",
                  padding: "4px 18px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {cat.label}
              </button>
            )
          })}
        </AvatarTabs>
        <AvatarGrid>
          {AVATARS_BY_CATEGORY[category].map(name => {
            const isSelected = name === currentAvatar
            return (
              <AvatarChoice
                key={name}
                type="button"
                aria-label={`Use ${name} avatar`}
                aria-pressed={isSelected}
                onClick={() => this.selectAvatar(name)}
              >
                <img alt="" src={avatarUrl(name)} />
              </AvatarChoice>
            )
          })}
        </AvatarGrid>
      </FrameC>
    )
  }

  renderPhoto = () => {
    const { user } = this.props
    const getUserId = get(user, "loadedUser._id", "000")
    const avatar =
      this.state.selectedAvatar || get(user, "loadedUser.avatar")
    const photoUrl = avatar
      ? avatarUrl(avatar)
      : `${PUBLIC_URL}/user/photo/${getUserId}?${new Date().getTime()}`
    const photoFallBack = `${ASSETS}/avatarm.png`
    return (
      <AvatarPreview>
        <img
          style={{ height: "auto", maxWidth: "100px", width: "100%" }}
          animate
          alt={"user"}
          src={photoUrl}
          onError={e => {
            if (e.target.src !== photoFallBack) {
              e.target.src = photoFallBack
            }
          }}
        />
      </AvatarPreview>
    )
  }

  render() {
    const { user, isExpanded, handleSubmit } = this.props
    const getName = get(user, "loadedUser.name")
    const getEmail = get(user, "loadedUser.email")
    const getAbout = get(user, "loadedUser.about")

    if (!this.isAuthenticated) {
      //return this.notAuthorized()
    }

    const type = {
      type: "button"
    }
    return (
      <Arwes>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <PageOffset isExpanded={isExpanded}>
            <MarginTop />
            <ContentColumn maxWidth={640}>
              <PageBlock>
            <Project animate header={"Edit Profile"}>
              <div style={{ padding: "8px 0" }}>
                {/*{this.renderPhoto()}*/}
                {this.renderEditPhoto()}
                <FrameC
                  show={true}
                  animate={true}
                  level={3}
                  corners={4}
                  layer="primary"
                >
                  <FieldBox>
                    <Hide enable={this.state.isEditName}>
                      <Field name="name" component={renderField} type="input" />
                    </Hide>
                    <Hide enable={!this.state.isEditName}>{getName}</Hide>
                  </FieldBox>
                  <ButtonBar>
                    <Button
                      buttonProps={type}
                      animate
                      layer="success"
                      onClick={this.enableEditName}
                    >
                      <Icon
                        path={mdiChemicalWeapon}
                        size={0.7}
                        color="green"
                        spin
                      />{" "}
                      Edit Name
                    </Button>
                  </ButtonBar>
                </FrameC>
                <FrameC
                  show={true}
                  animate={true}
                  level={3}
                  corners={4}
                  layer="primary"
                >
                  <FieldBox>
                    <Hide enable={this.state.isEditEmail}>
                      <Field
                        name="email"
                        component={renderField}
                        type="input"
                      />
                    </Hide>
                    <Hide enable={!this.state.isEditEmail}>{getEmail}</Hide>
                  </FieldBox>
                  <ButtonBar>
                    <Button
                      buttonProps={type}
                      type="button"
                      animate
                      layer="success"
                      onClick={this.enableEditEmail}
                    >
                      <Icon
                        path={mdiChemicalWeapon}
                        size={0.7}
                        color="green"
                        spin
                      />{" "}
                      Edit Email
                    </Button>
                  </ButtonBar>
                </FrameC>

                <FrameC
                  show={true}
                  animate={true}
                  level={3}
                  corners={4}
                  layer="primary"
                >
                  <FieldBox center>
                    <Hide enable={this.state.isEditPassword}>
                      <Field
                        name="password"
                        component={renderField}
                        type="input"
                      />
                    </Hide>
                    <Hide enable={!this.state.isEditPassword}>*****</Hide>
                  </FieldBox>
                  <ButtonBar>
                    <Button
                      buttonProps={type}
                      type="button"
                      animate
                      layer="control"
                      onClick={this.enableEditPassword}
                    >
                      <Icon
                        path={mdiChemicalWeapon}
                        size={0.7}
                        color="green"
                        spin
                      />{" "}
                      Edit Password
                    </Button>
                  </ButtonBar>
                </FrameC>

                <FrameC
                  show={true}
                  animate={true}
                  level={3}
                  corners={4}
                  layer="primary"
                >
                  <FieldBox center>
                    <Hide enable={this.state.isEditAbout}>
                      <Field name="about" component={renderField} type="text" />
                    </Hide>
                    <Hide enable={!this.state.isEditAbout}>{getAbout}</Hide>
                  </FieldBox>
                  <ButtonBar>
                    <Button
                      buttonProps={type}
                      type="button"
                      animate
                      layer="control"
                      onClick={this.enableEditAbout}
                    >
                      <Icon
                        path={mdiChemicalWeapon}
                        size={0.7}
                        color="green"
                        spin
                      />{" "}
                      Edit About
                    </Button>
                  </ButtonBar>
                </FrameC>
              </div>
              <ButtonBar right>
                <Button animate layer="success">
                  <Icon
                    path={mdiChemicalWeapon}
                    size={0.7}
                    color="green"
                    spin
                  />{" "}
                  Save Changes
                </Button>
              </ButtonBar>
            </Project>
              </PageBlock>
            </ContentColumn>
          </PageOffset>
        </form>
      </Arwes>
    )
  }
}

const validate = () => {
  return {}
}

const FORM_NAME = "EditProfile"
// enableReinitialize: initialValues arrive async (after the profile
// fetch), so the form must re-init when they land — otherwise every
// field starts undefined and saving corrupts the profile.
const form = reduxForm({ form: FORM_NAME, validate, enableReinitialize: true })(
  EditProfile
)

const mapStateToProps = state => {
  const getName = get(state.user, "loadedUser.name")
  const getEmail = get(state.user, "loadedUser.email")
  const getAbout = get(state.user, "loadedUser.about")

  const initialValues = {
    name: getName,
    email: getEmail,
    about: getAbout
  }
  return {
    formValues: getFormValues(FORM_NAME)(state),
    user: state.user,
    initialValues: initialValues
  }
}

export default connect(
  mapStateToProps,
  { checkIsAuthenticated, getUserInformation, editUserProfile }
)(form)
